import { ResourcesConfig } from 'aws-amplify';
import { ENV } from '../../environment';

type AmplifyConfig = ResourcesConfig;

const DevEnv: AmplifyConfig = {
  API: {
    GraphQL: {
      defaultAuthMode: 'userPool',
      endpoint: 'https://eoisw4netncjxhhhmf4wtchhzi.appsync-api.us-west-2.amazonaws.com/graphql',
      region: 'us-west-2',
    },
  },
  Auth: {
    Cognito: {
      allowGuestAccess: true,
      identityPoolId: 'us-west-2:f74c43da-d371-4c98-b70f-3a49fd75786a',
      loginWith: {
        oauth: {
          domain: 'concreitweb-tst.auth.us-west-2.amazoncognito.com',
          providers: [{ custom: 'Doorvest' }],
          redirectSignIn: ['https://invest.local.concreit.com:3000/partner-sign-in'],
          redirectSignOut: ['https://invest.local.concreit.com:3000/signout'],
          responseType: 'code',
          scopes: ['openid'],
        },
      },
      userPoolClientId: '38mjcbnjlhu3uma0o3e2vuc9e6',
      userPoolId: 'us-west-2_vEjLMn7CZ',
    },
  },
  Storage: {
    S3: {
      bucket: 'concreitweb-tst-appfiless3bucket-1kklqg8e6xgqp',
      region: 'us-west-2',
    },
  },
};

const StagingEnv: AmplifyConfig = {
  API: {
    GraphQL: {
      defaultAuthMode: 'userPool',
      endpoint: 'https://wmo5gie7ybde3oiuq7jmki56wm.appsync-api.us-west-2.amazonaws.com/graphql',
      region: 'us-west-2',
    },
  },
  Auth: {
    Cognito: {
      allowGuestAccess: true,
      identityPoolId: 'us-west-2:43678c52-3664-4a0a-9310-a8aa97a6fe24',
      loginWith: {
        oauth: {
          domain: 'concreitweb-staging.auth.us-west-2.amazoncognito.com',
          providers: [{ custom: 'Doorvest' }],
          redirectSignIn: ['https://invest.dev.concreit.com/partner-sign-in'],
          redirectSignOut: ['https://invest.dev.concreit.com/signout'],
          responseType: 'code',
          scopes: ['openid'],
        },
      },
      userPoolClientId: '9epk8rl193o0u9mj0ekfgfrc9',
      userPoolId: 'us-west-2_LsvhJLSwe',
    },
  },
  Storage: {
    S3: {
      bucket: 'concreitweb-staging-appfiless3bucket-1trv3rvjm9u7n',
      region: 'us-west-2',
    },
  },
};

const ProdEnv: AmplifyConfig = {
  API: {
    GraphQL: {
      defaultAuthMode: 'userPool',
      endpoint: 'https://qbdarcdmqjb5pcvlsdssxphabe.appsync-api.us-west-2.amazonaws.com/graphql',
      region: 'us-west-2',
    },
  },
  Auth: {
    Cognito: {
      allowGuestAccess: true,
      identityPoolId: 'us-west-2:65b3c14d-b0f5-4122-ba4e-a24a5a3ab9b3',
      loginWith: {
        oauth: {
          domain: 'concreitweb-prod.auth.us-west-2.amazoncognito.com',
          providers: [{ custom: 'Doorvest' }],
          redirectSignIn: ['https://invest.concreit.com/partner-sign-in'],
          redirectSignOut: ['https://invest.concreit.com/signout'],
          responseType: 'code',
          scopes: ['openid'],
        },
      },
      userPoolClientId: '7rkj8p1s9fgajqkek4u7us3p6q',
      userPoolId: 'us-west-2_lldozG5QM',
    },
  },
  Storage: {
    S3: {
      bucket: 'concreitweb-prod-appfiless3bucket-1qyxuqdpk8vr2',
      region: 'us-west-2',
    },
  },
};

export const config: AmplifyConfig = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
